import React from "react";

const TableHeader = (props) => {
    /*Metodos*/
    const { ordenarListaTarjeta } = props;

    return <thead>
        <tr>
            <th className="default-td clickable" onClick={() => { ordenarListaTarjeta("TarjetaCreditoNumero") }}>
                Nº
            </th>
            <th className="default-td clickable" onClick={() => { ordenarListaTarjeta("ClienteNombre") }}>
                NOMBRE
            </th>
            <th className="default-td clickable" onClick={() => { ordenarListaTarjeta("TarjetaTipoDescripcion") }}>
                TIPO
            </th>
            <th className="default-td clickable" onClick={() => { ordenarListaTarjeta("PorcentajeLimiteCompra") }}>
                LIMITE
            </th>
            <th className="default-td clickable" onClick={() => { ordenarListaTarjeta("TarjetaCreditoEstado") }}>
                ESTADO
            </th>
            {/*<th className="default-td clickable" onClick={() => { ordenarListaTarjeta("Vencimiento") }}>
                VENC
            </th>*/}
            <th></th>
        </tr>
    </thead>

}
export default TableHeader;